<div class="site-permission-editor-container d-flex flex-wrap">
  <div
    class="checkbox-wrapper w-25"
    *ngIf="(allSitesWithPermission | async).length > 1"
  >
    <mat-checkbox [checked]="allSelected" (change)="selectAllSite($event)"
      >Select All
    </mat-checkbox>
  </div>
  <div
    class="checkbox-wrapper pr-3 w-25"
    *ngFor="let site of allSitesWithPermission | async; let ind = index"
  >
    <div
      class="checkbox-wrapper-inner d-inline-flex flex-nowrap overflow-hidden w-auto"
    >
      <mat-checkbox
        class="label-truncatable text-ellipsis overflow-hidden min-width-0"
        [checked]="site.isPermitted"
        [title]="site.siteInfo.siteName"
        (change)="toggleSite($event, site.siteInfo.siteId, ind)"
        [disabled]="false"
        >{{ site.siteInfo.siteName }}
      </mat-checkbox>
      <mat-icon
        class="flex-shrink-0 ml-1"
        *ngIf="site.siteInfo.siteId === defaultSite"
        color="primary"
        title="Default Site"
        >star</mat-icon
      >
    </div>
  </div>
</div>
